<script>
    import {push, pop, replace} from 'svelte-spa-router'
	import { fade } from 'svelte/transition';
	import Header from './Header.svelte';
	import { springIn } from "svelte-helpers/spring-transitions";
	import { Line } from 'svelte-chartjs'
	import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale } from 'chart.js';

	import Modal, { bind } from 'svelte-simple-modal';
	import PopupMebot from './PopupMebot.svelte';
	import { writable } from 'svelte/store';
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';

	const modal = writable(null);


	ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale);

	let health_data = {
  labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
  datasets: [
    {
      label: 'Watts',
      fill: true,
      lineTension: 0.3,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      borderColor: 'hsl(185, 97%, 75%)',
      borderCapStyle: 'butt',
      borderDash: [],
	  borderWidth: 2,
      borderDashOffset: 0.0,
      borderJoinStyle: 'round',
	  pointRadius: 0,
      data: [50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50],
    },
  ],
};

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

	function set_section(name) {
        setCookie("section", name, 1)
    }

	const battleness = tweened(0, {
		duration: 200,
		easing: cubicOut
	});

	//set_section('health_stats');

    // The params prop contains values matched from the URL
    export let params = {}

    let dash_token = params.t
	if (dash_token != '1') {
		dash_token = getCookie("m_dash_token")
		if (dash_token == '' || dash_token == null) {
			dash_token = '1';
		}
	}

	let mebot_id = params.id
	let owner_mebot_id = params.id
	mebot_id = getCookie('m_id');
	owner_mebot_id = mebot_id;

	let owner_class = null;
	let stat_mebot_id = params.m_id

	//console.log('stat mebot id: ' + stat_mebot_id)
    let result = null
    let mebot_img_url = null;
    let mebot_i = null;
    let watts_score = '';
    let steps = '';
    let explorer = '';
    let social = '';
    let hrv = '';
    let mebot_badges = '';
    let m1 = null;
    let m2 = null;
    let mebot = [];
	let liking = false;
	let liked = false;
	let waving = false;
	let battling = false;
	let show_close = true;
	let timeout_id;
	let tag = '';
	let city_n = '';
	let hab_n = '';
	let total_n = ''
	let steps_info = '';
	let mood = '';
	let uh_n = '';
	let social_link = null;
	let social_msg = null;
	let copied = false;
	let chall_id = 0;
	let chall_desc = '';
	let can_battle = 0;

	async function fetchMebotStats (mebot_id = 0) {

		const stat_type = 1;
		let res = await fetch('https://api.forever.today/?method=get_mebot_stat', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id,
                stat_type
            })
		})

        let json = await res.json()
        result = json
        //json.data.mebots.forEach((x, i) => console.log(x));

        mebot = json.data.mebot;
		if (mebot.badges.length > 0) {
			mebot_badges = mebot.badges[0].em
		}

		//console.log('got mebot id: ' + mebot.id)
        //mebot_i = i;
		mebot_img_url = mebot.mebot_img_url;
		liked = mebot.is_liked;
		health_data.datasets[0].data = mebot.health;
		tag = mebot.tag;
		city_n = mebot.city_n;
		hab_n = mebot.hab_n;
		total_n = mebot.total_n;
		steps_info = mebot.steps_info;
		mood = mebot.mood;
		uh_n = mebot.uh_n;
		chall_desc = mebot.chall_desc;
		chall_id = mebot.chall_id;
		can_battle = mebot.cb;

		social_link = mebot.social_link;
		social_msg = mebot.social_msg;

		//if (mebot_id == owner_mebot_id) {
		if (dash_token != '1') {
			mebot_id = owner_mebot_id
			res = await fetch('https://api.forever.today/?method=get_mebot_stat', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id
            })
			})
    	    json = await res.json()
			result = json;
			owner_class = json.data.mebot.class;
			console.log(owner_class)
		}

		battleness.set(mebot.bas/100)
    }

    fetchMebotStats(stat_mebot_id)

	let charged = Math.random() * 0.0025 + 0.0005;
	charged = 0.0008;
	const SPRING_IN = { stiffness: charged, damping: 0.0012 };
	const animateIn = (node) => {
		const { duration, tickToValue } = springIn(-4, 0, SPRING_IN);
		return {
			duration: 50000,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

    /*
	const displayMebotDetails = async (e) => {
		var i = Number(e.target.dataset.cardId)
		console.log(i);
		if (i >= 0) {
			liked = false;

			mebot_i = i;
			console.log(mebots[i])
			mebot_img_url = mebots[i].mebot_img_url;
			liked = mebots[i].is_liked;
		}
	};*/

	function doNothing() {
		console.log('do nothing');
		return;
	}

	async function waveHandMebot() {
		console.log('do nothing');

		waving = true;
		setTimeout(function(){ waving = false; }, 600);
		let mebot_id = mebot.id;

		if (mebot_id > 0) {
			const res = await fetch(
				"https://api.forever.today/?method=wave_mebot",
				{
					method: "POST",
					body: JSON.stringify({
						dash_token,
						mebot_id
					}),
				}
			);
			const json = await res.json();
		}

		return;
	}

	async function battleMebot() {

		if (dash_token != '1') {
			battling = true;
			setTimeout(function(){ battling = false; }, 300);
			await sleep(300);
			push('/battle/2/' + mebot_id + '/' + stat_mebot_id)
		}
	}

	async function likeMebot() {
		console.log('do nothing');

		liking = true;
		setTimeout(function(){ liking = false; liked = true; }, 700);
		let mebot_id = mebot.id;

		if (mebot_id > 0) {

			mebot.is_liked = 1;
			const res = await fetch(
				"https://api.forever.today/?method=like_mebot",
				{
					method: "POST",
					body: JSON.stringify({
						dash_token,
						mebot_id
					}),
				}
			);
			const json = await res.json();
		}

		return;
	}

	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
	}


    function moon_phase(phase) {

		switch (phase) {
			case 1: return '🌘'
			case 2: return '🌗'
			case 3: return '🌖'
			case 4: return '🌕'
		}

		return '🌘'
	}

	function displayMebotMessage(msg, delay, action_button = false) {
		let is_show_close = false
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button }));
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

	function displayParsecDetails() {
		let msg = mebot.mp_days == 1 ? '1 day' : mebot.mp_days + ' days';
		if (mebot.mp_days >= 13) {
			msg = 'everyday'
		}

		displayMebotMessage(`
		<center>
			<br><br><br> ` + moon_phase(mebot.mp) + `<br><br>

		This Mebot has been active <b>` + msg + `</b> in the last two weeks.
		<br><br>
		Total days active: <b>` + mebot.parsecs + `</b>

		<br><br><br>
		</center>`, 7000);
	}

	function displayOwner() {

		displayMebotMessage(`
		<center>
			<br><br><br>
			You are the owner of this Mebot.
		<br><br><br>
		</center>`, 7000);
	}

	function displayStepDetails() {

		let msg = '';
//		if (mebot_14day_steps_n < 20) {
//			msg = '<br><br>Your Mebot could use some more movement!'
//		}

		displayMebotMessage(`
		<center>
			<br><br>
			<div class="text-electric" style="font-size: 65px;" >
			👟
			</div>
			<br>

		<b>` + mebot.steps_14day_av_info + `</b> 👟 avg / day (last 14 days)
		` + msg + `
		<br><br>

		<b>` +  total_n + `</b> total steps

		<br><br><br>
		</center>`, 7000, '👟');
	}

	function displayUnique() {

		displayMebotMessage(`
		<center>
			<br><br>
			Total habitats visited<br><br>
			<div class="text-electric" style="font-size: 30px;" >
				🚶‍♂️ <b>` +  uh_n + `</b> 🏠
			</div>
		<br><br><br>
		</center>`, 7000);
	}

	function habitatsOwned() {

		displayMebotMessage(`
		<center>
			<br><br>
			Habitats owned<br><br>
			<div class="text-electric" style="font-size: 30px;" >
				<b>` +  hab_n + `</b> 🏠
			</div>
			<br><br>
			Cities owned<br><br>
		<div class="text-electric" style="font-size: 30px;" >
				<b>` +  city_n + `</b> 🏙️
			</div>
		<br><br><br>
		</center>`, 7000);
	}

	function viewBadgeDetails(em, name, desc) {

		displayMebotMessage(`
		<center>
			<br><br>
			<div class="text-electric" style="font-size: 65px;" >
				<div> ` + em + ` </div>
			</div>
			<br>
			<b>` + name + `</b><br><br>
			` + desc + `
			<br><br>
		</center>`, 10000);
	}

	function copyToClipboard(textToCopy) {
		// navigator clipboard api needs a secure context (https)
		if (navigator.clipboard && window.isSecureContext) {
			// navigator clipboard api method'
			return navigator.clipboard.writeText(textToCopy);
		} else {
			// text area method
			let textArea = document.createElement("textarea");
			textArea.value = textToCopy;
			// make the textarea out of viewport
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			return new Promise((res, rej) => {
				// here the magic happens
				document.execCommand('copy') ? res() : rej();
				textArea.remove();
			});
		}
	}

	function copySuccess() {
		//copyError();
		//return;
		copied = true;
		if (copied == true) {
			setTimeout(
				function() {
					copied = false;
					showLinkCopied()
				},
			300
			);
		}
	}

	function copyError() {

		let tweet_msg = social_msg + social_link + ' @ForeveToday';

		let msg = `
		<center>
		<br><br>
		🔗 Mebot link:<br><br>
		<input value="` + social_link + `"></input>
		<br><br><br>`;

		if (social_msg != null) {
			msg = msg + `<br>
			🐦 Share tweet:<br><br>
			<textarea rows="4" cols="30">` + tweet_msg + `</textarea >
			<br><br><br>
			`
		}

		displayMebotMessage(msg, 100000);
	}

	function copyLink() {
		var copyText = document.getElementById("social_link");
		//alert("Copied the text: " + copyText.value);

		copyToClipboard(copyText.value)
			.then(() => copySuccess() )
			.catch(() => copyError() );
	}

	function showLinkCopied() {

		let tweet_msg = social_msg + social_link + ' @ForeveToday';

		let msg = `
		<center>
		<br><br><br>
		Mebot link 🔗<br> copied to your clipboard.<br><br>

		<br>`;

		if (social_msg != null) {
			msg = msg + `<br>
			🐦 Share tweet or post on Threads:<br><br>
			<textarea rows="4" cols="30">` + tweet_msg + `</textarea >
			<br><br>
			`
		}

		displayMebotMessage(msg, 100000, 'Copy');
	}

	function viewChallenge() {

		if (chall_id > 0) {

			if (dash_token == '1') {
				push('/chall/1/' + chall_id)
			} else{
				push('/chall/2/' + chall_id)
			}
		}
	}

    function alpha_mebot() {
        //return false;
		//return true;

		let m_id = owner_mebot_id;
		if (m_id == 2 || m_id == 76 || m_id == 87 || m_id == 1 || m_id == 59 || m_id == 396 || m_id == 459 || m_id == 110 || m_id == 338 || m_id == 250) {
		    return true;
		}
		return false;
	}
</script>

<Header
    header_mebot_id = { mebot_id }
	header_dash_token = { dash_token }
/>
<center>
	{#if mebot_img_url}
	<table width=300px border=0 height=240px>
		<tr>
			<td width="50px" valign=top align=center>
				<table border=0 height=240px>
					<tr>
						<td height="44px" align=center valign=middle>
							<span class="text-glow1 mebot-byline" style="font-size: 20px;"  on:click={ () => pop() }>
								✖️ 
							</span>
						</td>
					</tr>
					<tr>
						<td align=center valign=top>
							<br>
							<div class="text-glow" style="white-space: nowrap; font-size: 20px;">
								{#if mood != '' && mebot.class != 'Unhatched'}
									{ mood.em }
								{/if}
							</div>
						</td>
					</tr>
				</table>
			</td>
			<td width=200px>
				<div in:animateIn style="user-select: none;" >
					<!--<div
						href="/#/move/{dash_token}/{m_id}"
						style="user-select: none;"
					>-->
						<div on:click={ doNothing }>
						<img style="user-select: none;"
							on:click={ doNothing }
							src={mebot_img_url}
							width="230px"
							alt="meebot"
							class="no_tap_zoom"
						/>
						</div>
					<!--</div>-->
				</div>
			</td>
			<td width="100px" valign=top>
				<table border=0 height=240px>
					<tr>
						<td height="30px" align=center>
							<span class="text-glow mebot-byline">
								{@html tag}
							</span>
						</td>
					</tr>
					<tr>
						<td align=center valign=middle>
							<div class="text-glow" style="white-space: nowrap; font-size: 20px;">
								{#if mebot.is_owner == 0 }
								<br>
								<div class="controls" class:like-pulsing={ liking } on:click={ likeMebot }>
									{#if liked}
									🧡
									{:else}
									🤍
									{/if}
								</div>
								<div class="controls" class:hand-pulsing={ waving } on:click={ waveHandMebot }>
									👋
								</div>
								<!--
								{#if mebot.class == 'Trainer' && owner_class == 'Trainer' && mebot.is_owner == 0}-->
								{#if can_battle == 1 && mebot.is_owner == 0}

								<div on:click={battleMebot} style="margin-top: 22px;" class="text-electric1 text-blue submenu_active tooltip1">
									&nbsp;⚔️&nbsp;
									<br>
									<span style="font-size: 10px;">{ mebot.bas_info }</span>
								</div>
								{#if ($battleness > 0) }
								<div class="outer">
									<div class="progress_inner" style="width: {$battleness * 100}%; margin-top: 5px;" ></div>
								</div>
								{/if}

								{/if}

								{:else if mebot.class != 'Unhatched'}
								<div on:click={displayOwner}>
								👑
								</div>
								{/if}
							</div>
						</td>
					</tr>
					<tr>
						<td></td>
					</tr>
				</table>
			</td>
		</tr>
	</table>
	<table width=300px border=0>
		<!--
		{#if mebot_id == 76 || mebot_id == 87 || mebot_id == 250}
		<tr height=26px>
			<td width=55px>&nbsp;</td>
			<td align=right class="shadow_bg" width=180px colspan=2> <div class="vitals2 text-electric" style="white-space: nowrap;">&nbsp; <span style="position: relative;">🏆<span class="artifact__badge"> 7 </span></span>&nbsp;&nbsp; 🥈 <span style="position: relative;">🥊<span class="artifact__badge"> 2 </span></span>&nbsp;&nbsp; 🎧 〇 🎒 🛴 🛶 &nbsp;</div></td>
			<td width=60px>&nbsp;</td>
		</tr>
		{/if}-->
		{#if stat_mebot_id < 10000 }
		<tr height=20px>
			<td width=55px></td>
			<td align=left class="shadow_bg" width=120px><div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;⚡ &nbsp;Watt Level</div></td>
			<td align=right class="shadow_bg" width=60px><div class="vitals2 text-glow" style="white-space: nowrap;"> <b>{ mebot.watt_level }</b> &nbsp;</div></td>

			<td width=50px align=center valign=top on:click={ copyLink }>
				<div class="text-electric" >
					<input size="22" type="hidden" id="social_link" bind:value={social_link} >
					<span class="tooltip" style="font-size: 10px; white-space: nowrap;" class:copy-pulsing={ copied }> <span>&nbsp;🔗&nbsp;</span> </span>
				</div>
			</td>

		</tr>
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg"> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;🧭 &nbsp;Autopilot </div></td>
			<td align=right class="shadow_bg" width=60px> <div class="vitals2 text-glow" style="white-space: nowrap;"> { numberWithCommas(mebot.autopilot_level) } &nbsp;</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
<!--		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg"> <div class="vitals2 text-glow" style="white-space: nowrap;" on:click={displayParsecDetails}>&nbsp;{ moon_phase(mebot.mp) } &nbsp;Days Active </div></td>
			<td align=right class="shadow_bg" width=60px> <div class="vitals2 text-glow" style="white-space: nowrap;"> { mebot.mp_days }`{ mebot.parsecs } &nbsp;</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg"> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;🎮 &nbsp;Experience </div></td>
			<td align=right class="shadow_bg" width=60px> <div class="vitals2 text-glow" style="white-space: nowrap;"> { numberWithCommas(mebot.experience) } &nbsp;</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>-->
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg"> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;👑 &nbsp;Type </div></td>
			<td align=right class="shadow_bg" width=60px> <div class="vitals2 text-glow" style="white-space: nowrap;"> { numberWithCommas(mebot.type) } &nbsp;</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		{/if}
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg"> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;〰️ &nbsp;Class </div></td>
			<td align=right class="shadow_bg" width=60px> <div class="vitals2 text-glow" style="white-space: nowrap;"> { mebot.class_em } { numberWithCommas(mebot.class) } &nbsp;</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg"> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;🦾 &nbsp;Challenges </div></td>
			<td align=right class="shadow_bg" width=60px> <div class="vitals2 text-glow" style="white-space: nowrap;"> <span class="text-electric" class:challenge={ chall_desc.length > 3 } style="font-size: 12px;" on:click={ () => viewChallenge() }> { chall_desc } </span> &nbsp;</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		{#if mebot.badges.length > 0 }
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg"> <div class="vitals2 text-glow" style="white-space: nowrap;">&nbsp;📜 &nbsp;Badges <span class="text-electric" style="font-size: 12px;">{ mebot.badges.length }</span>  </div></td>
			<td align=right class="shadow_bg" width=60px> <div class="vitals2 text-glow badges-small" style="white-space: nowrap;"> &nbsp;
				{#each mebot.badges as ba, i}
				<span  on:click={ () => viewBadgeDetails(ba.em, ba.name, ba.desc) }> {ba.em} &nbsp; </span>
				{/each}
			</div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		{/if}
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td align=left class="shadow_bg"> <div class="vitals2 text-glow" style="white-space: nowrap;" on:click={habitatsOwned}>&nbsp;🏠 &nbsp;Habitats <span class="text-electric" style="font-size: 12px;">{ hab_n }</span>  &nbsp;</div></td>
			<td align=right class="shadow_bg" width=60px> <div class="vitals2 text-glow" style="white-space: nowrap;" on:click={habitatsOwned}>&nbsp;🏙️ &nbsp;Cities <span class="text-electric" style="font-size: 12px;">{ city_n }</span>  &nbsp;	</div></td>
			<td width=60px align=center>
				<div class="text-electric" style="white-space: nowrap; font-size: 12px;" on:click={displayUnique}>
					🚶‍♂️ { uh_n }
				</div>
			</td>
		</tr>
		{#if false }
		<tr height=10px>
			<td width=55px>&nbsp;</td>
			<td align=left>
			<div class="vitals2 text-glow" style="white-space: nowrap;">
				&nbsp;👑&nbsp; Owner
			</div></td>
			<td align=right width=50px> <div class="vitals2 text-glow" style="white-space: nowrap;"> &nbsp; </div> </td>
			<td width=60px>&nbsp;</td>
		</tr>
		{/if}
		{#if (stat_mebot_id > 0 && dash_token != '1') }
		<tr height=10px>
			<td width=55px align=center>
			</td>
			<td colspan=2 align=center class="shadow_bg">
				<div style="margin-top: 8px; margin-bottom: 8px;" on:click={displayStepDetails}>
				<Line data={health_data} height={20} width={175} options={
					{
						responsive: false,
						maintainAspectRatio: false,
						plugins: { legend: false, tooltip: false },
						scales: { x: {display: false, grid: {display: false}}, y: {display: false, max: 11000, grid: {display: false}} }
					}
				}
				/>
				</div>
			</td>
			<td width=60px align=center>
				<div class="vitals2 text-glow" style="white-space: nowrap;" on:click={displayStepDetails}>&nbsp;👟 <br>
					{total_n}
				</div>
			</td>
		</tr>
		<tr height=20px>
			<td width=55px>&nbsp;</td>
			<td colspan=2 align=center class="shadow_bg1">
				<div class="vitals2 text-glow" style="white-space: nowrap;">
					{@html steps_info}
				</div>
			</td>
			<td width=60px>&nbsp;</td>
		</tr>
		{/if}
	</table>
	{:else}
    <div class="snake_row">
    </div>
	{/if}

	<div class="small_row">
	</div>

</center>

{#if (dash_token == '1') }
<center>
	<br>
	<table cellpadding="2" cellspacing=0>
		<tr><td style="text-align:center">
			<a href="https://apps.apple.com/us/app/forever-steps/id1616422453" target="_new"><img src="https://app.mebots.xyz/img/ios_200.png" style="margin-top: 5px; padding: 4px;" height="35px"></a>
		</td><td style="text-align:center" valign="top">
			<a href="https://play.google.com/store/apps/details?id=today.forever.steps" target="_new"><img src="https://app.mebots.xyz/img/android_200.png" height="35px" style="margin-top: 5px; padding: 4px;"></a>
		</td></tr>
	</table>
</center>
{/if}

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<style>

	.text-blue {
		color: #00cafd;
	}
	.submenu_active {
        background-color: #202020;
        box-shadow: 0 5px 15px rgb(231, 247, 255);
    }
	.tooltip1 {
		margin-top: 0px;
		font-size: 12px;
		border-radius: 6px;
		border: 1px solid rgb(83, 83, 83);
		background-color: transparent;
		padding: 3px;
	}

	.outer {
		margin: 0px;
		background-color: transparent;
		border: 0px;
	}

	.progress_inner, .outer {
		height: 2px;
		border-radius: 0px;
	}

	.progress_inner {
		background-color: #00cafd;
		display: block;
		box-shadow: 0 0 8px rgb(0, 179, 255), 0 0 20px rgba(130, 132, 132, 0.819);
	}

	.challenge {
    	font-size: 12px;
    	border-radius: 2px;
    	border: 1px solid rgb(83, 83, 83);
    	background-color: #016c8a;
	}

	.text-electric {
        font-size: 14px;
		text-shadow: 0 0 8px rgba(192, 253, 255, 0.9),
			0 0 14px hsla(178, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}
	.shadow_bg {
		background:#7f7f7f;
		background:rgba(0,0,0,0.15);
		border-radius: 6px;
	}
	.snake_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		justify-content: center;
		margin-bottom: 10px;
	}
	.small_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		margin-bottom: 10px;
		margin-left: 40px;
		margin-right: 30px;
	}

	img {
		max-height: 90%;
	}

	.card {
        border-radius: 4px;
        color: rgb(216, 79, 0);
	}

	.text-glow {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: white;
	}

	.text-glow-electric {
		text-shadow: 0 0 10px rgba(64, 255, 249, 0.75),
			0 0 32px rgba(65, 246, 255, 0.88);
		font-family: arial;
		color: rgb(156, 255, 250);
	}

	.mebot-byline {
		font-size: 10px;
		white-space: nowrap;
	}

	.vitals2-grey {
		color: rgb(242, 248, 247);
		font-size: 14px;
	}

	.vitals2 {
		color: white;
		font-size: 12px;
	}

	.controls {
		font-size: 14px;
		margin-bottom: 20px;
	}

	.badges-small {
		font-size: 8px;
	}

	.mebot_active1 {
        border-radius: 15px;
        box-shadow: 0 3px 7px rgb(231, 247, 255);

        background: linear-gradient(114deg, #ffffff, #725cd8, #42e3ff, #42e3ff);
	    background-size: 800% 800%;

		-webkit-animation: AnimationName 6s ease infinite;
		-moz-animation: AnimationName 6s ease infinite;
		-o-animation: AnimationName 6s ease infinite;
		animation: AnimationName 6s ease infinite;
	}

    @-webkit-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-moz-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-o-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}

	.no_tap_zoom {
		touch-action: manipulation;
	}

	.copy-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.3s;
	}
	.like-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.5s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.hand-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.4s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.artifact__badge {
		background-color: rgb(0, 166, 181);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 6px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -4;
		right: 1;
	}

</style>